import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import AuthLayout from './components/AuthLayout';
import ForgotPassword from './routes/ForgotPassword';
import ResetPassword from './routes/ResetPassword';
import SignUp from './routes/SignUp';
import { URLS } from 'configs';

const Auth = () => {
  return (
    <AuthLayout>
      <Switch>
        <Route path='/auth/reset' component={ResetPassword} />
        <Route
          path='/auth/signin'
          render={() => {
            window.location.assign(URLS.CONTACT);
            return null;
          }}
        />
        <Route path='/auth/signup' component={SignUp} />
        <Route path='/auth/forgot' component={ForgotPassword} />
        <Redirect to='/' />
      </Switch>
    </AuthLayout>
  );
};

export default Auth;
